import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useRequestOld } from '@/hooks'
import { PROFESSIONAL_GROUPS, USER_GROUPS } from '@modules/admin/groups/constants'
import { createCustomerGroupRows, createProfessionalGroupRows } from '@modules/admin/groups/actions'
import Loading from '@modules/core/components/Loading'
import Table from '@modules/admin/common/table'
import CustomPagination from '@modules/tableComponents/Pagination'
import SearchField from '@modules/admin/common/fields/searchField'
import { Link } from 'react-router-dom'

import styled from 'styled-components'
import { RemoveModal } from '@modules/admin/groups/template'

export const Panel = ({ kind, className, columns, client, buttonText, filters }) => {
  const [selectedRemove, setSelectedRemove] = useState(null)
  const {
    t,
    i18n: { language: currentLanguage },
  } = useTranslation()

  const indexClient = (params) => client.index(params)
  const { data, loading, search, setSearch, pagination, fetch } = useRequestOld(indexClient, filters)
  const onChangeSearch = ({ target: { value } }) => setSearch(value)
  const displayRemoveModal = (item) => setSelectedRemove(item)
  const hideRemoveModal = () => setSelectedRemove(null)

  const removeGroup = async () => {
    try {
      await client.delete(selectedRemove.id)
      setSelectedRemove(null)
      await fetch()
    } catch (e) {
      console.error(e.message)
    }
  }
  const manageKindRows = () => {
    if (data) {
      if (kind === PROFESSIONAL_GROUPS)
        return createProfessionalGroupRows({
          columns,
          rows: data,
          kind,
          onDelete: displayRemoveModal,
        })
      else if (kind === USER_GROUPS)
        return createCustomerGroupRows({
          columns,
          rows: data,
          kind,
          onDelete: displayRemoveModal,
          currentLanguage,
        })
    }
  }
  const manageRemoveModalText = () => {
    if (kind === PROFESSIONAL_GROUPS)
      return (
        <>
          <label>{t('firstDisclaimerRemoveProfessionalGroup')}</label>
          <div>{t('secondaryDisclaimerRemoveProfessionalGroup')}</div>
        </>
      )
    else if (kind === USER_GROUPS)
      return (
        <>
          <label>{t('firstDisclaimerRemoveUserGroup')}</label>
          <div>{t('secondaryDisclaimerRemoveUserGroup')}</div>
        </>
      )
  }
  const rows = manageKindRows()

  let component
  if (loading) component = <Loading isFetching />
  else
    component = (
      <>
        <Table columns={columns} rows={rows} />
        <CustomPagination
          onClickItem={(page) => fetch(page)}
          activePage={pagination.currentPage}
          totalPages={pagination.lastPage}
          maxButtons={7}
        />
      </>
    )

  return (
    <div className={className}>
      <Wrapper>
        <SearchField placeholder={t('Buscar')} value={search} onChange={onChangeSearch} />
        <Link className="groupsCreateButton" to={`/groups/${kind}/create`}>
          + {buttonText}
        </Link>
      </Wrapper>
      {component}
      {selectedRemove && (
        <RemoveModal
          className="tight"
          hide={hideRemoveModal}
          confirmFn={removeGroup}
          text={manageRemoveModalText()}
          t={t}
        />
      )}
    </div>
  )
}
const Wrapper = styled.div`
  display: flex;
  align-items: center;

  & > div {
    flex: 1;
    margin-right: 10px;
  }
`
